export function is_admin_user(props) {
    return props.role === 'admin' || props.role === 'gallery'
}

export function is_premium_plan(props) {
    if(is_admin_user(props)) {
        return true
    }
    if (props.plan.type) {
        if (props.plan.type === 'basic' || props.plan.type === 'default') return false
    }
    return true
}